import axios from 'axios';
import { configRefs } from '@utils/config';

async function getAllRevisionsRequest(user, courseId) {
  if (!user || !courseId || !user.institution?.id) {
    return [];
  }
  switch (user.role) {
    case "teacher":
      {
        const res = await axios.get(`${await configRefs.apis.userdata.get()}/api/CourseRevisions/?userID=${encodeURIComponent(user.id)}&institutionID=${user.institution.id}&courseID=${encodeURIComponent(courseId)}`);
        if (!res.data) {
          return [];
        }
        return mapResponse(res.data);
      }
    case "student":
      {
        const res = await axios.get(`${await configRefs.apis.userdata.get()}/api/CourseRevisions/shared?studentID=${encodeURIComponent(user.id)}&studentTeam=${encodeURIComponent(user.institution.class ?? "")}&institutionID=${encodeURIComponent(user.institution.id)}&courseID=${encodeURIComponent(courseId)}`);
        if (!res.data) {
          return [];
        }
        return mapResponse(res.data);
      }
  }
}
function mapResponse(res) {
  return res.map(rawRevision => ({
    id: rawRevision.objectID,
    __clientId: rawRevision.objectID,
    __syncedWithBackend: true,
    courseId: rawRevision.courseID,
    portalId: rawRevision.portalID,
    userId: rawRevision.userID,
    isActive: rawRevision.isActive,
    name: rawRevision.title,
    disabledContentIds: JSON.parse(rawRevision.content)
  }));
}

export { getAllRevisionsRequest };
//# sourceMappingURL=request.get-all.js.map
